module.exports = __webpack_public_path__ + "static/img/abtus_bg_2.077d762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/abtus_bg_2.png
// module id = XqlH
// module chunks = 0